import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageTitleComponent } from '../_components/page-title/page-title.component';
import { BreadcrumbComponent } from '../_components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-viewer',
  imports: [RouterOutlet, PageTitleComponent,BreadcrumbComponent],
  templateUrl: './viewer.component.html',
  styleUrl: './viewer.component.scss'
})
export class ViewerComponent {

}
